import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setSessionToken } from '../lib/api';
import { useAuth } from '../lib/auth';
import { Sparkles } from 'lucide-react';

export default function AuthCallback() {
  const nav = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || '';
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) { nav('/'); return; }
    const session_id = m[1];

    (async () => {
      try {
        const r = await api.post('/auth/session', { session_id });
        setSessionToken(r.data.session_token);
        setUser(r.data.user);
        // clean hash
        window.history.replaceState({}, '', window.location.pathname);
        nav('/app/dashboard', { state: { user: r.data.user } });
      } catch (e) {
        console.error(e);
        nav('/');
      }
    })();
  }, [nav, setUser]);

  return (
    <div className="min-h-screen grid place-items-center">
      <div className="ambient-bg" />
      <div className="glass p-10 text-center">
        <Sparkles size={32} className="text-[#C2A878] mx-auto mb-3 animate-pulse" />
        <div className="font-serif text-xl">Signing you in…</div>
      </div>
    </div>
  );
}
